/**
 * The lead score's hover text, shared by the board card and the record so the
 * two never explain the same number differently.
 *
 * The score arrives already computed (src/automations/cardScore.js), under the
 * after-hours automation's weights as they are saved now. The chips are each
 * group's share of the score in score points, so they add up to it
 * (src/automations/scoreParts.js); `floor_points` is what the floor at 0 added
 * back when penalties outweighed everything else.
 */
export function leadScoreTitle(s) {
  if (!s) return "";
  if (s.blocked_reason) return `Lead score 0: ${s.blocked_reason}`;
  const parts = (s.chips || [])
    .filter((c) => c.points)
    .map((c) => `${c.label} ${c.points > 0 ? "+" : ""}${c.points}`);
  if (s.floor_points) parts.push(`floor +${s.floor_points}`);
  const chips = parts.join(" · ");
  const verdict = s.passes ? `at or above the threshold of ${s.threshold}` : `below the threshold of ${s.threshold}`;
  return `Lead score ${s.score}/100, ${verdict}, under the automation's current weights${chips ? `. ${chips}` : ""}`;
}
